export default function IdealExperienceSection() {
  const cards = [
    {
      num: "01",
      title: "好きな靴で出かけられる",
      desc: "「帰り道につらくなる」を前提にしなくていい。好きな靴を、当たり前に履ける日常へ。",
      bg: "bg-[#1C1917]",
      textColor: "text-white",
      descColor: "text-white/50",
      numColor: "text-white/20",
      image: null,
    },
    {
      num: "02",
      title: "自分の足に合うを知る",
      desc: "サイズだけではなく、足の骨格・幅・特徴まで見る。それが、本当のフィッティングです。",
      bg: "bg-[#F5F0EA]",
      textColor: "text-[#1C1917]",
      descColor: "text-[#78716C]",
      numColor: "text-[#1C1917]/10",
      image: "https://readdy.ai/api/search-image?query=professional%20female%20shoe%20fitter%20gently%20measuring%20customer%20foot%20in%20elegant%20minimalist%20shoe%20boutique%2C%20warm%20cream%20interior%2C%20soft%20natural%20lighting%2C%20close%20up%20hands%20on%20foot%2C%20warm%20ivory%20tones%2C%20caring%20and%20professional%20atmosphere&width=600&height=700&seq=ideal2&orientation=portrait",
    },
    {
      num: "03",
      title: "無理なく履ける",
      desc: "楽な靴に逃げるのではなく、好きな靴を、自分の足で履きやすくする。",
      bg: "bg-[#FAFAF8]",
      textColor: "text-[#1C1917]",
      descColor: "text-[#78716C]",
      numColor: "text-[#1C1917]/10",
      image: null,
    },
  ];

  return (
    <section className="bg-[#F5F0EA] py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-7 gap-3">
          <div>
            <p
              className="text-[#B8895A] text-xs tracking-widest mb-2 uppercase"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              Ideal
            </p>
            <h2
              className="text-2xl md:text-3xl font-bold text-[#1C1917] leading-snug"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              <span className="italic">"綺麗なのに楽"</span> は、ちゃんと両立できます。
            </h2>
          </div>
          <p
            className="text-[#78716C] text-sm leading-relaxed max-w-xs"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            健康靴ではなく、あなたの「好き」をそのまま履けるようにする。それがレディースキッドの考え方です。
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {cards.map((card, i) => (
            <div
              key={i}
              className={`relative rounded-2xl overflow-hidden flex flex-col ${card.bg} min-h-[240px]`}
            >
              {card.image && (
                <div className="absolute inset-0">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917]/80 via-[#1C1917]/20 to-transparent" />
                </div>
              )}
              <div className="relative z-10 p-6 flex flex-col justify-between h-full min-h-[240px]">
                <div
                  className={`text-4xl font-bold ${card.numColor}`}
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  {card.num}
                </div>
                <div>
                  <h3
                    className={`text-base font-bold leading-snug mb-2 ${
                      card.image ? "text-white" : card.textColor
                    }`}
                    style={{ fontFamily: "'Noto Serif JP', serif" }}
                  >
                    {card.title}
                  </h3>
                  <p
                    className={`text-xs leading-relaxed ${card.image ? "text-white/70" : card.descColor}`}
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {card.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}